import { render, staticRenderFns } from "./TermsOfServices.vue?vue&type=template&id=af504644&scoped=true&"
import script from "./TermsOfServices.vue?vue&type=script&lang=js&"
export * from "./TermsOfServices.vue?vue&type=script&lang=js&"
import style0 from "./TermsOfServices.vue?vue&type=style&index=0&id=af504644&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af504644",
  null
  
)

export default component.exports